import React from 'react';
import { Map } from 'immutable';
import { compose, mergeDeepRight } from 'ramda';

import Form from '@synergycms_core/components/generic/Form';
import InputField from '@synergycms_core/components/generic/Form/InputField.jsx';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import styleFile from './CustomerForm.js';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import connect from 'react-redux/es/connect/connect';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Price from '@synergycms_core/components/generic/Price';
import { RichText } from '@synergycms_core/components/generic/';
import EPGClass from '@synergycms_core/utils/tpv/epgGeneric';
import SelectPayForm from '../../components/functional/CustomerForm/SelectPayform.jsx';
import actions from '../../store/actions';
import RadioGroupField from '@synergycms_core/components/generic/Form/RadioGroupField';
import {
    LoadingFragment,
    LoadingConfirmation,
    EPGContainer
} from '../../components/functional/CustomerForm/SmallComponents';
import GiftVoucherForm from '../../components/functional/GiftVoucherForm/GiftVoucherForm';
import MainSideSummary from '../../components/functional/MainSideSummary/MainSideSummary';
import ConditionsModal from "../../components/functional/CustomerForm/ConditionsModal";
import { correctSelection, getUrlConfirmation } from "../../utils/utils";
import storage from "synergycms_core/src/utils/storage";
import RedsysClass from '@synergycms_core/utils/tpv/redsys';
import SelectCountry from '@synergycms_core/components/functional/CustomerForm/SelectCountry.jsx';

const { customer: customerActions } = actions;

const customerPatchFields = [
    'name',
    'surname',
    'email',
    'phone',
    'country',
    'country_iso_code',
    'blocks',
    'GDPR_accepted',
    'trv_reference'
];
const bookingPatchFields = customerPatchFields.slice().concat('status', 'payment');

const CustomerForm = class CustomerForm extends React.Component {
    static displayName = 'CustomerForm';
    /** @type {boolean | string} */
    tpvEnabled = false;
    /** @type {EPGClass|null } */
    EPG = null;
    /** @type {RedsysClass|null } */
    REDSYS = null;
    /** @type {string | null} */
    paymentToken = null;
    /** @type {string | null} */
    selectedCountry = null;
    /** @type {string} */
    formID = 'customerBookingForm';
    /** @type {array} */
    errors = [];
    /** @type {number} */
    retriesTpv = 0;

    constructor(props) {
        super(props);
        const {
            reservation,
            countries,
            tpvPaymentStatus,
            showErrorNotification,
            tpv,
            trackingId,
            updateTrackingId,
            hotel
        } = this.props.config;

        this.tpvEnabled = tpv.getIn(['name'], false);
        if (this.tpvEnabled === 'EPG') {
            this.EPG = new EPGClass(
                process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
                'giftVoucher',
                reservation,
                tpvPaymentStatus,
                showErrorNotification
            );
        } else if (this.tpvEnabled === 'Redsys') {
            this.REDSYS = new RedsysClass(
                process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
                reservation,
                hotel,
                tpvPaymentStatus,
                () => { },
                () => { },
                showErrorNotification
            );
        }

        updateTrackingId(trackingId);

        this.state = {
            payFormSelected: 'op',
            prepayTokenEPG: false,
            showCardValidationError: false
        };

        this.defaultCountry = this.selectedCountry =
            countries.find(country => country.get('alpha2') === this.props.config.defaultCountryCode) ||
            countries.find(country => country.get('alpha2') === 'ES');

        if (this.tpvEnabled === 'EPG') {
            window.addEventListener('message', this.EPG.receiveMessage, false);
        }
    }

    componentWillUnmount = () => {
        if (this.tpvEnabled === 'EPG') {
            window.removeEventListener('message', this.EPG.receiveMessage, false);
        }
    };


    componentDidMount(prevProps, prevState, snapshot) {
        this.retriesTpv = 0;
        window.onerror = (message, url, line, column, error) => {
            let errorMessage = '';
            if (error) {
                errorMessage = typeof error.stack !== 'undefined' ? error.stack : error.toString();
            }
            errorMessage += ' -> ' + navigator.userAgent;

            this.errors.push({
                url: window.document.location.href,
                message: message,
                error: errorMessage
            });
        };
    }

    checkTpvContainer = () => {
        const { showErrorNotification, managementGroupID, formCurrency, trackingId, hotel } = this.props.config;

        setTimeout(() => {
            const stopRetries = 10;
            if (this.tpvEnabled === 'EPG') {
                const submitButtonwindow = document.querySelector('#' + this.EPG.submitButton);
                if (!submitButtonwindow) {
                    this.retriesTpv++;
                    if (this.retriesTpv <= stopRetries) {
                        this.EPG.initialize(
                            managementGroupID ? 'management_groups' : 'hotels',
                            managementGroupID ? managementGroupID : hotel.get('id'),
                            trackingId,
                            this.selectedCountry.get('alpha2'),
                            formCurrency,
                            this.props.config.langCode.toLowerCase(),
                            this.formID,
                            showErrorNotification,
                            this.setStateEPGPrepaymentToken,
                            this.checkTpvContainer
                        );
                    }
                }
            }
        }, 2000);
    };

    setStateEPGPrepaymentToken = prepayTokenEPG => {
        this.setState(state =>
            mergeDeepRight(state, {
                prepayTokenEPG: prepayTokenEPG
            })
        );
    };

    validatePaymentForms = (validForm, inputList, manageLoading) => {
        const {
            reservation,
            hotel,
            amountToPay,
            showConfirmation,
            formCurrency,
            showErrorNotification,
            trackingId,
            managementGroupID,
            confirmationUrl
        } = this.props.config;


        // scroll to first unvalid
        if (!validForm) {
            const firstUnvalidKey = Object.keys(inputList).find(k => inputList[k].validation && inputList[k].validation.valid === false);
            if (firstUnvalidKey) {
                this.refs[firstUnvalidKey].scrollIntoView();
                window.scrollBy(0, -65);
            } else {
                validForm = true;
            }
        }

        manageLoading(true);
        return new Promise((resolve, reject) => {
            switch (this.state.payFormSelected) {
                case 'op':
                    if (validForm) {
                        switch (this.tpvEnabled) {
                            case 'EPG':
                                this.EPG.validatePayment(this.onSubmit, validForm, inputList, resolve, reject);
                                break;
                            case 'Redsys':
                                this.onSubmit(validForm, inputList, resolve, reject);
                                break;
                            default:
                                reject(Error('not valid form'));
                                break;
                        }
                    } else {
                        reject(Error('not valid form'));
                    }
                    break;
                default:
                    break;
            }
        }).then(response => {

            const reservationResponse = storage.get('gift_voucher_reservation_confirmation');
            const trackingID = storage.get('gift_voucher_reservation_merchant_tid');
            if (reservationResponse && reservationResponse.length > 0) {
                if (this.state.payFormSelected !== 'op') {
                    this.props.config.showConfirmation();
                } else if (this.tpvEnabled === 'EPG') {

                    //this.props.config.showConfirmation(confirmationUrl);
                    if (validForm && this.EPG.prepayToken !== false) {
                        // en EPG es fa el pagament després de confirmar la reserva.
                        return this.EPG.chargePayment(
                            inputList,
                            managementGroupID ? 'management_groups' : 'hotels',
                            managementGroupID ? managementGroupID : hotel.get('id'),
                            trackingId,
                            storage.get('gift_voucher_reservation_confirmation'),
                            confirmationUrl,
                            formCurrency,
                            this.selectedCountry.get('alpha2'),
                            this.props.config.langCode.toLowerCase(),
                            this.formID,
                            showConfirmation,
                            showErrorNotification,
                            this.setStateEPGPrepaymentToken,
                            this.checkTpvContainer,
                            manageLoading,
                            storage.get('gift_voucher_reservation_merchant_tid')
                        );
                    }
                } else if (this.tpvEnabled === 'Redsys') {
                    if (validForm) {
                        this.REDSYS.initializeGeneric(
                            hotel,
                            trackingID,
                            amountToPay,
                            'gift_voucher',
                            confirmationUrl,
                        ).then(() => {
                            this.REDSYS.validatePayment();
                        });
                    }
                }
            }
        })
            .catch(error => {
                if (this.tpvEnabled === 'EPG' && this.EPG.onSubmitPromiseReject) {
                    return this.EPG.onSubmitPromiseReject(error);
                } else {
                    return error;
                }
            });

    };

    onSubmit = (validForm, inputList, resolve, reject) => {
        const { triggerEvent } = this.props.config;

        if (!validForm) {
            const firstUnvalidKey = Object.keys(inputList).find(k => inputList[k].validation && inputList[k].validation.valid === false);
            if (!firstUnvalidKey) {
                validForm = true;
            }
        }

        if (validForm) {
            const { confirmBooking } = this.props.config;
            let promise, errorType;

            errorType = 'unknown';
            promise = confirmBooking(inputList, this.paymentToken);

            return promise
                .tapCatch(() => triggerEvent('confirm_error', errorType))
                .then(resolve)
                .catch(reject);
        } else {
            return reject(Error('Invalid form'));
        }
    };

    onBlur = (validForm, inputList, model, stateRetriever, managementGroupID, formCurrency) => {
        const { trackingId, showErrorNotification, hotel } = this.props.config;
        if (model === 'payForm') {
            this.onChangePayForm(validForm, inputList, model, stateRetriever);
        } else {
            if (model === 'country') {
                this.selectedCountry = inputList['country'].value;
                if (this.tpvEnabled === 'EPG') {
                    this.EPG.initialize(
                        managementGroupID ? 'management_groups' : 'hotels',
                        managementGroupID ? managementGroupID : hotel.get('id'),
                        trackingId,
                        this.selectedCountry.get('alpha2'),
                        formCurrency,
                        this.props.config.langCode.toLowerCase(),
                        this.formID,
                        showErrorNotification,
                        this.setStateEPGPrepaymentToken,
                        this.checkTpvContainer
                    );
                }
            }
            this.props.config.saveCustomerData(validForm, inputList, model);
        }
    };

    onChangePayForm = (validForm, inputList, model, stateRetriever) => {
        const { reservation, managementGroupID, showErrorNotification, changePayForm, formCurrency, trackingId, hotel, amountToPay } = this.props.config;

        if (this.tpvEnabled === 'EPG') {
            // l'assignem aquí per tenir-lo disponible en posteriors events de reset
            this.EPG.successEvent = this.EPG.onValidate(
                stateRetriever,
                this.validatePaymentForms,
                this.setStateEPGPrepaymentToken,
                trackingId
            );
        }
        //       const payFormCode = inputList['payForm'] && inputList['payForm'].value.get('code');
        //       if (payFormCode) {

        return new Promise(resolve => {
            resolve();
        }).then(() => {
            changePayForm(validForm, inputList, this.tpvEnabled);
            if (this.tpvEnabled === 'EPG' && this.EPG.loadingTpvAuth === false) {
                this.EPG.initialize(
                    managementGroupID ? 'management_groups' : 'hotels',
                    managementGroupID ? managementGroupID : hotel.get('id'),
                    trackingId,
                    this.selectedCountry.get('alpha2'),
                    formCurrency,
                    this.props.config.langCode.toLowerCase(),
                    this.formID,
                    showErrorNotification,
                    this.setStateEPGPrepaymentToken,
                    this.checkTpvContainer
                );
            }
            this.setState(state =>
                mergeDeepRight(state, {
                    payFormSelected: 'op'
                })
            );
        });
        //        }
    };

    render() {
        const { config, theme } = this.props,
            {
                reservation,
                langCode,
                currentCurrencyCode,
                countries,
                amountToPay,
                formCurrency,
                showAddresse,
                showNewsCheck,
            } = config;

        const { classes } = theme.styles;

        return (
            <div className={classes.defaultStyle}>
                <div className={classes.page}>
                    <div className={classes.section}>
                        <RichText innerStyle={[classes.title]} ucFirst={true} translate={true}>
                            _%realiza tu compra%_
                        </RichText>
                        <Form
                            disableLoading={true}
                            loadingTemplate={LoadingConfirmation}
                            id={this.formID}
                            onChange={this.onChange}
                            onBlur={this.onBlur}
                            onSubmit={this.validatePaymentForms}
                            onMount={this.onChangePayForm}
                            innerStyle={classes.customerForm}>
                            <div>

                                <div className={[classes.boxContainer, classes.borderedBox].join(' ')}>
                                    <RichText innerStyle={[classes.title]} ucFirst={true} translate={true}>
                                        _%tus Datos%_
                                    </RichText>
                                    <label className={classes.inputBox} ref={'name'}>
                                        <InputField
                                            model={'name'}
                                            defaultValue={reservation.getIn(['customer', 'name'], '')}
                                            innerStyle={['inputText', classes.inputText]}
                                            validationsFields={{ field: 'nombre' }}
                                            validations={[
                                                'required',
                                                { type: 'maxLength', maxLength: 100 },
                                                { type: 'minLength', minLength: 2 }
                                            ]}
                                        />
                                        <InputNotify model={'name'} />
                                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre%_'}
                                            translate={true} />
                                    </label>
                                    <label className={classes.inputBox} ref={'surname'}>
                                        <InputField
                                            model={'surname'}
                                            defaultValue={reservation.getIn(['customer', 'surname'], '')}
                                            innerStyle={['inputText', classes.inputText]}
                                            validationsFields={{ field: 'apellidos' }}
                                            validations={[
                                                'required',
                                                { type: 'maxLength', maxLength: 100 },
                                                { type: 'minLength', minLength: 2 }
                                            ]}
                                        />
                                        <InputNotify model={'surname'} />
                                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%apellidos%_'}
                                            translate={true} />
                                    </label>
                                    <label className={classes.inputBox} ref={'email'}>
                                        <InputField
                                            model={'email'}
                                            defaultValue={reservation.getIn(['customer', 'email'], '')}
                                            validationsFields={{ field: 'email' }}
                                            validations={['required', 'email']}
                                            innerStyle={['inputText', classes.inputText]}
                                            type={'email'}
                                        />
                                        <InputNotify model={'email'} />
                                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%email%_'}
                                            translate={true} />
                                    </label>
                                    <label className={classes.inputBox} ref={'repeatEmail'}>
                                        <InputField
                                            model={'repeatEmail'}
                                            defaultValue={reservation.getIn(['customer', 'email'], '')}
                                            validationsFields={{ field: 'repetir email' }}
                                            validations={[
                                                'required',
                                                'email',
                                                {
                                                    type: 'compareField',
                                                    alterModel: 'email',
                                                    alterField: 'email'
                                                }
                                            ]}
                                            innerStyle={['inputText', classes.inputText]}
                                            type={'email'}
                                        />
                                        <InputNotify model={'repeatEmail'} />
                                        <RichText
                                            innerStyle={[classes.labelText]}
                                            ucFirst={true}
                                            text={'_%repetir email%_'}
                                            translate={true}
                                        />
                                    </label>
                                    <div className={classes.phoneContainer}>
                                        <SelectCountry defaultCountry={this.defaultCountry} countries={countries}
                                            arrowPosition={langCode} />

                                        <label className={classes.inputBox} ref={'phone'}>
                                            <InputField
                                                model={'phone'}
                                                defaultValue={reservation.getIn(['customer', 'phone'], '')}
                                                validationsFields={{ field: 'teléfono' }}
                                                validations={['required', 'phone']}
                                                innerStyle={['inputText', classes.inputText]}
                                                type={'tel'}
                                            />
                                            <InputNotify model={'phone'} />
                                            <RichText innerStyle={[classes.labelText, 'capitalize']}
                                                text={'_%teléfono%_'}
                                                translate={true} />
                                        </label>
                                    </div>

                                </div>
                                <div className={showAddresse ? [classes.boxContainer, classes.borderedBox].join(' ') : classes.hide}>
                                    <RichText innerStyle={classes.title} ucFirst={true} translate={true}>
                                        _%opciones de entrega%_
                                    </RichText>
                                    <RadioGroupField
                                        defaultValue={reservation.getIn(['customer', 'receiver'], 'customer')}
                                        model={'receiver'}
                                        innerStyle={['inputRadio', classes.radioButtonContainer]}
                                        options={[
                                            {
                                                value: 'customer',
                                                text: 'correo electrónico del comprador',
                                                translate: true,
                                                ucFirst: true,
                                                innerStyle: ['roboto14Gray300', classes.radioButtonElement]
                                            },
                                            {
                                                value: 'addressee',
                                                text: 'correo electrónico del destinatario',
                                                translate: true,
                                                ucFirst: true,
                                                innerStyle: ['roboto14Gray300', classes.radioButtonElement]
                                            }
                                        ]}
                                    />
                                </div>
                                {
                                    reservation.getIn(['customer', 'receiver'], 'customer') !== 'customer' &&
                                    <div className={[classes.boxContainer, classes.borderedBox].join(' ')}>
                                        <RichText innerStyle={[classes.title]} ucFirst={true} translate={true}>
                                            _%datos destinatario%_
                                        </RichText>
                                        <label className={classes.inputBox} ref={'name_addressee'}>
                                            <InputField
                                                model={'name_addressee'}
                                                defaultValue={reservation.getIn(['customer', 'name_addressee'], '')}
                                                innerStyle={['inputText', classes.inputText]}
                                                validationsFields={{ field: 'nombre' }}
                                                validations={[
                                                    { type: 'maxLength', maxLength: 100 },
                                                    { type: 'minLength', minLength: 2 }
                                                ]}
                                            />
                                            <InputNotify model={'name_addressee'} />
                                            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre%_'}
                                                translate={true} />
                                        </label>
                                        <label className={classes.inputBox} ref={'surname_addressee'}>
                                            <InputField
                                                model={'surname_addressee'}
                                                defaultValue={reservation.getIn(['customer', 'surname_addressee'], '')}
                                                innerStyle={['inputText', classes.inputText]}
                                                validationsFields={{ field: 'apellidos' }}
                                            />
                                            <InputNotify model={'surname_addressee'} />
                                            <RichText innerStyle={[classes.labelText, 'capitalize']}
                                                text={'_%apellidos%_'}
                                                translate={true} />
                                        </label>
                                        <label className={classes.inputBox} ref={'email_addressee'}>
                                            <InputField
                                                model={'email_addressee'}
                                                defaultValue={reservation.getIn(['customer', 'email_addressee'], '')}
                                                validationsFields={{ field: 'email_addressee' }}
                                                validations={['email']}
                                                innerStyle={['inputText', classes.inputText]}
                                                type={'email_addressee'}
                                            />
                                            <InputNotify model={'email_addressee'} />
                                            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%email%_'}
                                                translate={true} />
                                        </label>
                                        <label className={classes.inputBox} ref={'repeatEmail_addressee'}>
                                            <InputField
                                                model={'repeatEmail_addressee'}
                                                defaultValue={reservation.getIn(['customer', 'email_addressee'], '')}
                                                validationsFields={{ field: 'repetir email' }}
                                                validations={[
                                                    'email',
                                                    {
                                                        type: 'compareField',
                                                        alterModel: 'email_addressee',
                                                        alterField: 'email'
                                                    }
                                                ]}
                                                innerStyle={['inputText', classes.inputText]}
                                                type={'email'}
                                            />
                                            <InputNotify model={'repeatEmail_addressee'} />
                                            <RichText
                                                innerStyle={[classes.labelText]}
                                                ucFirst={true}
                                                text={'_%repetir email%_'}
                                                translate={true}
                                            />
                                        </label>
                                    </div>
                                }

                                <div className={classes.boxContainer}>
                                    <RichText innerStyle={[classes.title]} ucFirst={true} translate={true}>
                                        _%personaliza tu regalo%_
                                    </RichText>
                                    <GiftVoucherForm
                                        blocks={reservation.get('blocks')}
                                        langCode={langCode}
                                        currency={currentCurrencyCode}
                                        onBlur={this.props.config.updateBlock}
                                    />
                                </div>
                                <div className={[classes.boxContainer, classes.lastBox].join(' ')}>
                                    {showNewsCheck &&
                                        <label className={classes.checkBox}>
                                            <CheckboxField
                                                defaultValue={reservation.getIn(['customer', 'GDPR_accepted'], false)}
                                                type={'checkbox'}
                                                model={'GDPR_accepted'}
                                                innerStyle={['inputCheck', classes.inputCheck]}
                                            />

                                            <RichText
                                                translate={true}
                                                ucFirst={true}
                                                innerStyle={['GDPR_accepted']}
                                                text={
                                                    '_%deseo que el hotel me informe de novedades de sus servicios y/o productos%_'
                                                } //TODO el text eurostars hotels a de ser dinàmic
                                            />
                                        </label>
                                    }
                                    <label className={[classes.checkBox, classes.oblig].join(' ')}
                                        ref={'required_policies'}>
                                        <CheckboxField
                                            defaultValue={reservation.getIn(['customer', 'required_policies'], false)}
                                            type={'checkbox'}
                                            validations={['required']}
                                            validationsFields={{ field: '' }}
                                            model={'required_policies'}
                                            innerStyle={['inputCheck', classes.inputCheck]}
                                            css={{ invalid: null, valid: null }}
                                        />
                                        <RichText translate={true} ucFirst={true}
                                            text={'_%sí, he leído y acepto la siguiente%_'} />{' '}
                                        <ConditionsModal group={'eurostarshotels'} />{' '}
                                        <RichText translate={true} text={'_%y%_'} />{' '}
                                        <RichText translate={true} ucFirst={true} text={'_%términos y condiciones de los Bonos%_'} />{' '}
                                        <InputNotify model={'required_policies'} css={{ valid: null }} />
                                    </label>
                                </div>
                            </div>
                            {
                                this.tpvEnabled !== 'Redsys' && <div className={classes.paymentMethod}>
                                    <RichText ucFirst={true} innerStyle={[classes.title]}
                                        translate={true}>
                                        _%datos de pago%_
                                    </RichText>
                                    <SelectPayForm defaultValue={'op'}
                                        reservationPaid={false} />
                                </div>
                            }
                            {
                                this.tpvEnabled === 'EPG' && <EPGContainer
                                    tpvEnabled={this.tpvEnabled}
                                    epgCashierContainer={this.EPG ? this.EPG.cashierContainer : null}
                                    epgPrepayToken={this.EPG ? this.EPG.prepayToken : null}
                                    payFormSelected={this.state.payFormSelected}
                                    reservationPaid={false}
                                />
                            }
                            {this.state.showCardValidationError && (
                                <div className={classes.errorPCI}>
                                    <RichText
                                        text={
                                            '_%ha ocurrido un error con tu tarjeta. Comprueba que los datos introducidos sean correctos.%_'
                                        }
                                        translate={true}
                                        innerStyle={['errorForm15']}
                                        ucFirst={true}
                                    />
                                </div>
                            )}
                            <div className={classes.finalPrice}>
                                <div className={classes.tableContainer}>
                                    <div className={classes.tableCell}>
                                        <RichText
                                            text={'_%importe total que se cargará a la tarjeta de crédito por esta compra%_'}
                                            innerStyle={[classes.totalPrice]} ucFirst={true}
                                            translate={true} />{' '}
                                        <Price hotelCurrencyCode={formCurrency}
                                            innerStyle={['bold', classes.totalPrice]} amount={amountToPay} />
                                    </div>
                                    <div className={classes.buttonContainer}>
                                        <ButtonSubmit
                                            richText={{
                                                text: '_%confirmar reserva%_',
                                                translate: true,
                                                ucFirst: true,
                                                innerStyle: ['toggleSecondButton'],
                                                rightIcon: {
                                                    unicodeContent: config.langCode === 'AR' ? '005C' : 'e000',
                                                    innerStyle: ['size12', 'absoluteButton']
                                                }
                                            }}
                                            innerStyle={['toggleSecondButton']}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                    <div className={classes.summaryContainer}>
                        <MainSideSummary />
                    </div>
                </div>
            </div>
        );
    }
};

const mapDispatchToProps = (dispatch, ownProps, state) => {
    const { reservation } = ownProps;
    return {
        updateTrackingId: (trackingId) => {
            dispatch(actions.customer.params.updateParams(Map({ 'tracking_id': trackingId })));
            dispatch(actions.router.update());
        },
        saveCustomerData: (validForm, inputList, model) => {
            return dispatch(customerActions.reservationRequest.update(model, inputList));
        },
        changePayForm: (validForm, inputList, tpvCode) => {
            const validationFields = ['email'];
            if (
                validationFields.every(
                    field => (inputList[field] && inputList[field].validation && inputList[field].validation.valid) || typeof inputList[field].validation === "undefined"
                )
            ) {
                let tpvObj = {};
                if (tpvCode) {
                    tpvObj = { tpvCode: tpvCode };
                }
                dispatch(customerActions.reservationRequest.update('payment', inputList, tpvObj));
            }
        },
        updateBlock: (valid, inputList, blockIdx) => {
            dispatch(customerActions.reservationRequest.update('gift_voucher', inputList, {
                blockIdx,
                callbackByField: false
            }));
        },
        confirmBooking: (inputList, paymentToken) => {
            //validació per si les mosques, no hauria de ser necessari

            const validationFields = ['email'];
            if (
                validationFields.every(
                    field => (inputList[field] && inputList[field].validation && inputList[field].validation.valid) || typeof inputList[field].validation === "undefined"
                )
            ) {
                return dispatch(customerActions.reservationRequest.postAsync());
            } else {
                return Promise.reject();
            }
        },
        confirmBookingEPG: (inputList, payed, trackingId, tpvId, tpvCode, paymentToken, nRetry) => {
            //validació per si les mosques, no hauria de ser necessari
            const validationFields = ['email'];
            if (
                validationFields.every(
                    field => (inputList[field] && inputList[field].validation && inputList[field].validation.valid) || typeof inputList[field].validation === "undefined"
                )
            ) {
                return dispatch(
                    customerActions.reservationRequest.update(bookingPatchFields, inputList, {
                        paymentToken: paymentToken,
                        payed: payed,
                        merchantTransactionId: `${trackingId}-${nRetry}`,
                        tpvId: tpvId,
                        tpvCode: tpvCode,
                        EPGnRetry: nRetry,
                        extraFields: true
                    })
                );
            } else {
                return Promise.reject();
            }
        },
        showConfirmation: (url) => {
            window.location.replace(url);
            //dispatch(actions.router.update());
            return true;
        },
        showErrorNotification: text => {
            dispatch(actions.notifications.send('error', text));
            window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
        }
    };
};

const mapStateToProps = (store, ownProps) => {

    const reservation = store.getIn(["customer", "reservation_request"]);

    return {
        tpv: store.get("tpv"),
        langCode: store.getIn(['customer', 'lang_info', 'code']).toUpperCase(),
        tpvPaymentStatus: store.getIn(['customer', 'params', 'params', 'tpv_result'], false),
        managementGroupID: store.getIn(['customer', 'current_management_group', 'id'], false),
        hotel: store.getIn(['customer', 'current_hotel'], Map()),
        amountToPay: reservation.get("blocks").reduce((price, block) => {
            return price + parseFloat(block.get("price"));
        }, 0),
        countries: store.get('countries'),
        defaultCountryCode: store.getIn(['customer', 'country', 'code'], 'ES'),
        formCurrency: store.getIn(['customer', 'form_currency']),
        currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
        reservation: reservation,
        showAddresse: store.getIn(['customer', 'show_addresse']),
        showNewsCheck: store.getIn(['customer', 'show_news_check']),
        trackingId: store.getIn(['customer', 'tracking_id']),
        correctSelection: correctSelection(),
        confirmationUrl: getUrlConfirmation()
    };
};

export default compose(
    validateAsyncComponent(mapStateToProps, [], LoadingFragment),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    PropertyManager([
        'changePayForm',
        'confirmBooking',
        'tpvPaymentStatus',
        'confirmBookingEPG',
        'langCode',
        'saveCustomerData',
        'showConfirmation',
        'showErrorNotification',
        'countries',
        'defaultCountryCode',
        'managementGroupID',
        'hotel',
        'reservation',
        'amountToPay',
        'currentCurrencyCode',
        'formCurrency',
        'tpv',
        'updateBlock',
        'trackingId',
        'updateTrackingId',
        'showAddresse',
        'showNewsCheck',
        'correctSelection',
        'confirmationUrl'
    ]),
    withThemeJSS({ styleFile, link: true })
)(CustomerForm);